import { accountTypeCredit, accountTypeLoan } from "_helpers/credit";

export const previewData = [
  {
    id: 1,
    selected: true,
    tradeline: {
      accountNumber: "1234567890",
      customerName: "Bank of America",
      balanceAmount: "1000",
      accountType: "01",
      openOrClosed: "O",
    },
  },
  {
    id: 2,
    selected: true,
    tradeline: {
      accountNumber: "9876543210",
      customerName: "Chase",
      balanceAmount: "2500",
      accountType: "01",
      openOrClosed: "O",
    },
  },
  {
    id: 3,
    selected: true,
    tradeline: {
      accountNumber: "4567891230",
      customerName: "Wells Fargo",
      balanceAmount: "3750",
      accountType: "01",
      openOrClosed: "O",
    },
  },
  {
    id: 4,
    selected: true,
    tradeline: {
      accountNumber: "7891234560",
      customerName: "Capital One",
      balanceAmount: "1250",
      accountType: "01",
      openOrClosed: "O",
    },
  },
  {
    id: 5,
    selected: true,
    tradeline: {
      accountNumber: "3216549870",
      customerName: "Discover",
      balanceAmount: "4200",
      accountType: "01",
      openOrClosed: "O",
    },
  },
  {
    id: 6,
    selected: true,
    tradeline: {
      accountNumber: "9632587410",
      customerName: "American Express",
      balanceAmount: "5500",
      accountType: "01",
      openOrClosed: "O",
    },
  },
].sort((a, b) => {
  return b.tradeline.balanceAmount - a.tradeline.balanceAmount;
});

export const getApprovedTradelines = (tradelines) => {
  return tradelines
    .filter((t) => {
      const isApproved =
        accountTypeLoan.includes(t.tradeline.accountType) ||
        accountTypeCredit.includes(t.tradeline.accountType);
      const balanceAmount = parseInt(t.tradeline?.balanceAmount || 0);
      const isOpen = t.tradeline.openOrClosed === "C" ? false : true;
      if (isApproved && balanceAmount > 0 && isOpen) {
        return true;
      } else {
        return false;
      }
    })
    .sort((a, b) => {
      return b.tradeline.balanceAmount - a.tradeline.balanceAmount;
    });
};

export const getEligibleBalance = (tradelines) => {
  return tradelines.reduce((acc, t) => {
    const balanceAmount = parseInt(t.tradeline?.balanceAmount || 0);
    return acc + balanceAmount;
  }, 0);
};
